import { get, post, put, deleted } from '..';
import routes from './routes';

const SystemSettingsServices = {
  createSystemSettings: async (obj) => {
    const data = await post(routes.createSystemSettings, obj);
    return data;
  },
  getSystemSettings: async () => {
    const data = await get(routes.getSystemSettings);
    return data;
  },
  getActiveSystemSettings: async () => {
    const data = await get(routes.getActiveSystemSettings);
    return data;
  },
  updateSystemSettings: async (id, obj) => {
    const data = await put(routes.updateSystemSettings + id, obj);
    return data;
  },
  deleteSystemSettings: async (id) => {
    const data = await deleted(routes.deleteSystemSettings + id);
    return data;
  },
};

export default SystemSettingsServices;